import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddCountryCrncy from "./AddCountryCrncy";
import DelCountryCrncy from "./DelCountryCrncy";
import EditCountryCrncy from "./EditCountryCrncy";
import ReactPaginate from "react-paginate";

class CountryCrncy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      showDelModel: false,
      showAddModel: false,
      showEditModal: false,
      ItemList: "",
      page: 0,
      perPage: 10,
    };
  }

  componentDidMount() {
    this.props.fetchCountryList();
    this.props.fetchCurrencyList();
    this.props.fetchCntryCrnvy();
  }
  handleAddCountry = () => {
    this.setState({
      showAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showAddModel: false,
    });
  };

  handleDelCategory = (item) => {
    this.setState({
      showDelModel: true,
      deleteItem: item,
    });
  };
  closeDelModel = () => {
    this.setState({ showDelModel: false });
  };

  editmodel = (item) => {
    // this.props.fetchCatgryById(item)
    this.setState({
      showEditModal: true,
      ItemList: item,
    });
  };
  closeEdtModel = () => {
    this.setState({
      showEditModal: false,
    });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.cntryCrncySelectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  render() {
    let p = this.state.page + 1;
    let count =
      this.props.cntrycrncyListCount && this.props.cntrycrncyListCount;
    let cntryCrncyPageCount = Math.ceil(count / this.state.perPage);
    return (
      <div>
        <div>
          <Card>
            <Card.Header>
              <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
                <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                  <h3>Country Currency</h3>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <div className="countryRecrd">
                    <i className="cui-note icons cmnRecordIcon"></i>
                    <span className="cmnPageCount">
                      {count !== 0 && count !== undefined ? count : 0}
                    </span>
                    <span className="cmnResutText">Results</span>
                  </div>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <div>
                <Button
                  style={{ marginBottom: "15px" }}
                  onClick={() => this.handleAddCountry()}
                >
                  <i className="fa fa-plus fa-md"></i>
                  <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                    ADD
                  </span>
                </Button>
                <AddCountryCrncy
                  showAddModel={this.state.showAddModel}
                  closeAddModel={this.closeAddModel}
                  CountrysList={this.props.CountrysList}
                  CurrencyList={this.props.CurrencyList}
                  fetchCountryById={this.props.fetchCountryById}
                  AddCntryCrncy={this.props.AddCntryCrncy}
                  resetPage={this.resetPage}
                />
              </div>
              <div>
                <Table responsive bordered striped className="cmnMainTable">
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th style={{ width: "70px" }}>SL NO</th>
                      <th>COUNTRY NAME</th>
                      <th>CURRENCY NAME</th>
                      <th>ACTIVE </th>
                      <th>ACTION </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.cntrycrncyList &&
                      this.props.cntrycrncyList.map((item, i) => (
                        <tr key={i}>
                          <td>{10 * (p - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {item.countryId !== null && item.countryId.name}
                          </td>
                          <td className="cmn_Cap">
                            {item.currencyId !== null && item.currencyId.name}
                          </td>
                          <td>
                            {item !== null && item.isActive ? "Yes" : "No"}
                          </td>
                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-edit fa-lg "
                                style={{ paddingLeft: 10 }}
                                onClick={() => this.editmodel(item)}
                              ></i>

                              <EditCountryCrncy
                                showEditModal={this.state.showEditModal}
                                closeEdtModel={this.closeEdtModel}
                                ItemList={this.state.ItemList}
                                CountrysList={this.props.CountrysList}
                                CurrencyList={this.props.CurrencyList}
                                EditCntryCurency={this.props.EditCntryCurency}
                                resetPage={this.resetPage}
                              />
                              <i
                                className="fa fa-trash fa-lg"
                                style={{ paddingLeft: 10 }}
                                onClick={() => this.handleDelCategory(item)}
                              ></i>
                              <DelCountryCrncy
                                showDelModel={this.state.showDelModel}
                                closeDelModel={this.closeDelModel}
                                deleteItem={this.state.deleteItem}
                                DeleteCrntryCrncy={this.props.DeleteCrntryCrncy}
                                resetPage={this.resetPage}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>

                {(this.props.cntrycrncyList === undefined ||
                  (this.props.cntrycrncyList &&
                    this.props.cntrycrncyList.length === 0)) && (
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require("../../../assets/img/nodata4.png")}
                      />
                    </div>
                    <div className="noDataTextDiv">No Mappings Found</div>
                  </div>
                )}
              </div>
            </Card.Body>

            {cntryCrncyPageCount > 1 ? (
              <div className="paginationDiv">
                <ReactPaginate
                  forcePage={this.state.page}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={cntryCrncyPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination flex-wrap"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            ) : null}
          </Card>
        </div>
      </div>
    );
  }
}

export default CountryCrncy;
